import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { useContext } from "react"
import { useUpdateUserTerms } from "../../api/queries/useUpdateUserTerms"
import userContext from "../../context/user"

export default function TermsConfirm({ show, callback }: Props) {
  const { user } = useContext(userContext)
  const updateUserTerms = useUpdateUserTerms(user?.uuid)

  const onHide = (): void => callback(false)
  const header = (): string => "Obchodní podmínky"
  const onClick = async (): Promise<void> => {
    await updateUserTerms.mutateAsync({ isTermsConfirmed: true })
    onHide()
    callback(true)
  }

  return (
    <Dialog visible={show} onHide={onHide} header={header} draggable={false}>
      <p>Před odesláním objednávky musíte souhlasit s <a
        href={"https://www.dopravanapaletach.cz/web/op.csp"}
        target={"_blank"} rel={"noreferrer"}
        className={"text-primary"}>obchodními podmínkami</a>.</p>

      <div className={"text-right"}>
        <Button label={"Souhlasím"} icon={"pi pi-check"} onClick={onClick} />
      </div>
    </Dialog>
  )
}

interface Props {
  show: boolean;
  callback: (success: boolean) => void;
}
